import { Component, OnInit } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import {LoginService} from '../login.service';

@Component({
  selector: 'app-enrollmentsummary',
  templateUrl: './enrollmentsummary.component.html',
  styleUrls: ['./enrollmentsummary.component.scss']
})
export class EnrollmentsummaryComponent implements OnInit {
    refDate:null;
    provider:null;
    assessDate:null;
    startDate:null;
    empendDate:null;
    statusCd:null;
    statusDate:null;
    endDate:null;
    reasonCd:null;
    closed:any='N';
    county:any = null;

  constructor(public toastService:ToastrService, public loginService:LoginService) { }

  ngOnInit() {
    this.load();
  }
  load(){
    let request = {
      perId:this.loginService.personId
    };
    this.loginService.enrollmentSummary(request).subscribe((data)=>{
      this.refDate=data['refDate'];
      if(data['county'] !== null){
        this.county = this.loginService.staticData.get("COUNTIES").find(obj => obj.value == data['county']).name;
      }
      this.provider=data['provider'];
      this.assessDate=data['assessDate'];
      this.startDate=data['startDate'];
      this.empendDate=data['empendDate'];
      if(data['statusCd'] != undefined){
        this.statusCd=this.loginService.staticData.get("EMPLOYMENT_PLAN_STATUS").find(obj => obj.value == data['statusCd']).name;
      }
      if(data['reasonCd'] != undefined){
        this.reasonCd=this.loginService.staticData.get("CASE_CLOSURE_REASON").find(obj => obj.value == data['reasonCd']).name;
      }
      this.statusDate=data['statusDate'];
      this.endDate=data['endDate'];
      if(data['endDate'] != null){
        this.closed = 'Y';
      }
    },error=>{
      this.toastService.error('Unable to load enrollment summary','My Information');
    })
  }
}



// WEBPACK FOOTER //
// ./src/app/enrollmentsummary/enrollmentsummary.component.ts